import { useTranslation } from 'react-i18next';
import { Form, InputNumber, Select } from 'antd';
import { CONTAINER_SIZES } from 'shared/constants/container-sizes';
import { containerTypeOptions, rules } from './constants';
import styles from './container-cargo-item-input-fields.module.scss';
import type { IContainerCargoItemInputFieldsProps } from './types';

export const ContainerCargoItemInputFields: React.FC<IContainerCargoItemInputFieldsProps> = (props) => {
  const { form, name } = props;

  const { t } = useTranslation('cargo');

  const fieldName = (field: string) => (name ? [name, field] : field);
  const containerType = Form.useWatch(fieldName('type'), form);
  const size = containerType ? CONTAINER_SIZES[containerType as keyof typeof CONTAINER_SIZES] : undefined;

  return (
    <div className={styles.container}>
      <Form.Item
        name={fieldName('type')}
        rules={rules.type}
        label={t('container_type')}
        rootClassName={styles.inputBox}>
        <Select options={containerTypeOptions} placeholder={t('container_type')} />
      </Form.Item>
      <Form.Item label={t('length_label')} rootClassName={styles.inputBox}>
        <InputNumber value={size?.length} decimalSeparator=',' controls={false} disabled />
      </Form.Item>
      <Form.Item label={t('width_label')} rootClassName={styles.inputBox}>
        <InputNumber value={size?.width} decimalSeparator=',' controls={false} disabled />
      </Form.Item>
      <Form.Item label={t('height_label')} rootClassName={styles.inputBox}>
        <InputNumber value={size?.height} decimalSeparator=',' controls={false} disabled />
      </Form.Item>
      <Form.Item
        name={fieldName('weight')}
        rules={rules.weight}
        label={t('weight_label')}
        rootClassName={styles.inputBox}>
        <InputNumber decimalSeparator=',' controls={false} min={1} />
      </Form.Item>
    </div>
  );
};
